<template>
  <div>
    <div class="package-items-stage">
      <div class="row">
        <!-- Title -->
        <div class="stage-title">Pozycje z zamówienia</div>
        <hr />
      </div>
      <div class="row">
        <PackagesManagerItemsList :orderGuid="orderGuid"/>
      </div>
      <FloationgBackButton @backAction="goBack()" />
    </div>
  </div>
</template>

<script>
import PackagesManagerItemsList from "./PackagesManagerItemsList.vue";
import FloationgBackButton from "@/components/widgets/FloatingBackButton.vue";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PackagesManagerItemsStage",
  components: { PackagesManagerItemsList, FloationgBackButton },
  props: {
    orderGuid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentOrderGuid:null,
    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    userAuthenticated: {
      handler(newValue) {
        if (!newValue) {
          this.$router.push(`/login`);
        }
      },
      deep: true,
    },
  },
  created() {
    if(this.orderGuid && this.orderGuid.length > 0) {
      console.log("Using orderGuid from props: ", this.orderGuid);
      this.currentOrderGuid = this.orderGuid;
    } else {
      console.log("Using orderGuid from route query: ", this.$route.query.orderGuid);
      this.currentOrderGuid = this.$route.query.orderGuid;
    }

    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>
.package-items-stage {
  background: #fafafa;
  margin-left: 16px;
  margin-right: 16px;
}
</style>
